import { DATATYPE_COLUMN_WIDTH } from '../../../lib/const.js';
import { validateNull } from '../../../lib/validate';
import { ft } from '../../../lib/utils';
import commonApi from '../../../lib/api/index';

const fixSelectDic = [{ from: 'taxCode', to: 'taxRate' }];

const LABELS = {
  integerOrDecimalGreater: ft('i18n_common_integer_or_decimal_greater', '大于 ? 的整数或小数'),
  no: ft('i18n_common_no', '否 '),
  numberGreater: ft('i18n_common_number_greater', '大于 ? 的数字'),
  numberGreaterAndLessEqual: ft(
    'i18n_common_number_greater_equal_and_less_equal',
    '大于 ? 并且小于等于 ? 的数字'
  ),
  numberGreaterEqual: ft('i18n_common_number_greater_equal', '大于等于 ? 的数字'),
  numberGreaterEqualAndLessEqual: ft(
    'i18n_common_number_greater_equal_and_less_equal',
    '大于等于 ? 并且小于等于 ? 的数字'
  ),
  numberWithTowDecimal: ft('i18n_common_numbers_with_two_decimal_places', '包含两位小数的数字'),
  pleaseEnter: ft('i18n_common_please_enter', '请输入 '),
  yes: ft('i18n_common_yes', '是'),
  yesOrNo: ft('i18n_common_yes_or_no', '是否')
};

export const getFilePath = () => {
  let projectName;

  if (top.location.pathname) {
    projectName = top.location.pathname.split('/')[1];
  }

  const projectPath = projectName ? `projectName/` : '';

  return '/' + projectPath + 'opt/nfsshare/';
};

export const checkFixDic = (item, list) => {
  fixSelectDic.map((dicItem) => {
    if (dicItem.from === item.prop) {
      item.type = 'select';
      commonApi.getDic(item.prop).then((res) => {
        item.dicData = res.data.data;
      });
    }
  });
};

export const updateBizDic = (list) => {
  list.map((item) => {
    if (item.dicUrl) {
      commonApi.getDic(item.bizDic).then((res) => {
        item.dicData = res.data.data;
      });
    }
  });
};

export function addRules(rule, rules) {
  let existsRule = false;

  for (const item of rules) {
    if (rule.required) {
      if (item.required && rule.trigger === item.trigger) {
        existsRule = true;
      }
    } else if (rule.trigger === item.trigger) {
      if (
        item.validator &&
        item.validator.name &&
        rule.validator &&
        rule.validator.name &&
        item.validator.name === rule.validator.name
      ) {
        existsRule = true;
      }
    }
  }

  if (!existsRule) {
    rules.push(rule);
  }
}

export async function checkDataType(item) {
  const dateList = ['noteDate', 'deliveryDate', 'confirmDate', 'needDate'];
  const dateTimeList = ['createDate', 'lastUpdateDate', 'validUntilTime'];

  if (dateList.includes(item.prop)) {
    item.datatype = 'date';
  }

  if (dateTimeList.includes(item.prop)) {
    item.datatype = 'datetime';
  }

  switch (item.datatype) {
    case 'popup':
      item.formslot = true;
      item.slot = true;
      item.width = DATATYPE_COLUMN_WIDTH[item.datatype];
      break;
    case 'popupName':
      item.disabled = 'disabled';
      break;
    case 'input':
      item.type = 'input';
      break;
    case 'textarea':
      item.type = 'textarea';
      item.span = 24;
      break;
    case 'uploadImg':
      item.disabled = 'disabled';
      item.type = 'img';
      break;
    case 'uploadFile':
      item.disabled = 'disabled';
      item.type = 'url';
      break;
    case 'data':
    case 'date':
      item.type = 'date';
      item.format = 'yyyy-MM-dd';
      item.valueFormat = 'timestamp';
      break;
    case 'datatime':
    case 'datetime':
      item.type = 'datetime';
      item.format = 'yyyy-MM-dd HH:mm:ss';
      item.valueFormat = 'timestamp';
      break;
    case 'price':
      item.type = 'number';
      item.precision = 2;
      // setValidatePrice(item);
      break;
    case 'number':
      setValidateNumber(item);
      item.type = 'number';
      break;
    case 'boolean':
      item.type = 'select';
      item.dicData = [
        { label: LABELS.no, value: 'N' },
        { label: LABELS.yes, value: 'Y' }
      ];
      break;
    case 'radio':
      item.type = 'radio';
      break;
    case 'bizDic':
      item.type = 'select';

      if (!(item.dicData && !item.bizDic)) {
        item.bizDic = item.bizDic || item.prop;
      }
      break;
  }

  if ((item.label && item.label.includes('是否')) || item.label.includes(LABELS.yesOrNo)) {
    item.type = 'select';
    item.dicData = [
      { label: LABELS.no, value: 'N' },
      { label: LABELS.yes, value: 'Y' }
    ];
  }

  if (!validateNull(item.bizDic)) {
    if (item.type !== 'radio') {
      item.type = 'select';
    }

    await updateBizDicItem(item);
  }
}

export async function checkDataType4Vxe(item) {
  const dateList = ['noteDate', 'deliveryDate', 'confirmDate', 'needDate'];
  const dateTimeList = ['createDate', 'lastUpdateDate', 'validUntilTime'];

  if (dateList.includes(item.prop)) {
    item.datatype = 'date';
  }

  if (dateTimeList.includes(item.prop)) {
    item.datatype = 'datetime';
  }

  switch (item.datatype) {
    case 'popup':
      item.formslot = true;
      item.slot = true;
      item.width = DATATYPE_COLUMN_WIDTH[item.datatype];
      break;
    case 'popupName':
      item.disabled = 'disabled';
      break;
    case 'input':
      item.type = 'input';
      break;
    case 'textarea':
      item.type = 'textarea';
      item.span = 24;
      break;
    case 'uploadImg':
      item.disabled = 'disabled';
      item.type = 'img';
      break;
    case 'uploadFile':
      item.disabled = 'disabled';
      item.type = 'url';
      break;
    case 'data':
    case 'date':
      item.type = 'date';
      item.format = 'yyyy-MM-dd';
      item.valueFormat = 'timestamp';
      break;
    case 'datatime':
    case 'datetime':
      item.type = 'datetime';
      item.format = 'yyyy-MM-dd HH:mm:ss';
      item.valueFormat = 'timestamp';
      break;
    case 'price':
      item.type = 'number';
      item.precision = 2;
      // setValidatePrice(item);
      break;
    case 'number':
      setValidateNumber4Vxe(item);
      break;
    case 'boolean':
      item.type = 'select';
      item.dicData = [
        { label: LABELS.no, value: 'N' },
        { label: LABELS.yes, value: 'Y' }
      ];
      break;
    case 'radio':
      item.type = 'radio';
      break;
    case 'bizDic':
      item.type = 'select';

      if (!(item.dicData && !item.bizDic)) {
        item.bizDic = item.bizDic || item.prop;
      }
      break;
  }

  if ((item.label && item.label.includes('是否')) || item.label.includes(LABELS.yesOrNo)) {
    item.type = 'select';
    item.dicData = [
      { label: LABELS.no, value: 'N' },
      { label: LABELS.yes, value: 'Y' }
    ];
  }

  if (!validateNull(item.bizDic)) {
    if (item.type !== 'radio') {
      item.type = 'select';
    }

    await updateBizDicItem(item);
  }
}

export function fixDataType(item) {
  const dateList = ['noteDate', 'deliveryDate', 'confirmDate', 'needDate'];
  const dateTimeList = ['createDate', 'lastUpdateDate', 'validUntilTime'];

  if (dateList.includes(item.prop)) {
    item.datatype = 'date';
  }

  if (dateTimeList.includes(item.prop)) {
    item.datatype = 'datetime';
  }

  switch (item.datatype) {
    case 'popup':
      item.formslot = true;
      item.slot = true;
      item.width = DATATYPE_COLUMN_WIDTH[item.datatype];
      break;
    case 'popupName':
      item.disabled = 'disabled';
      break;
    case 'input':
      item.type = 'input';
      break;
    case 'textarea':
      item.type = 'textarea';
      item.span = 24;
      break;
    case 'uploadImg':
      item.disabled = 'disabled';
      item.type = 'img';
      break;
    case 'uploadFile':
      item.disabled = 'disabled';
      item.type = 'url';
      break;
    case 'data':
    case 'date':
      item.type = 'date';
      item.format = 'yyyy-MM-dd';
      item.valueFormat = 'timestamp';
      break;
    case 'datatime':
    case 'datetime':
      item.type = 'datetime';
      item.format = 'yyyy-MM-dd HH:mm:ss';
      item.valueFormat = 'timestamp';
      break;
    case 'price':
      item.type = 'number';
      item.precision = 2;
      // setValidatePrice(item);
      break;
    case 'number':
      setValidateNumber(item);
      item.type = 'number';
      break;
    case 'boolean':
      item.type = 'select';
      item.dicData = [
        { label: LABELS.no, value: 'N' },
        { label: LABELS.yes, value: 'Y' }
      ];
      break;
    case 'radio':
      item.type = 'radio';
      break;
    case 'bizDic':
      item.type = 'select';

      if (!(item.dicData && !item.bizDic)) {
        item.bizDic = item.bizDic || item.prop;
      }
      break;
  }

  if ((item.label && item.label.includes('是否')) || item.label.includes(LABELS.yesOrNo)) {
    item.type = 'select';
    item.dicData = [
      { label: LABELS.no, value: 'N' },
      { label: LABELS.yes, value: 'Y' }
    ];
  }

  // if (!validateNull(item.bizDic)) {
  //   item.type = 'select';
  //   await updateBizDicItem(item);
  // }
}

export const handlerSystemFiled = (item) => {
  // const systemData = [];
  const systemTime = ['createDate', 'interfaceTime', 'lastUpdateDate'];
  const systemText = ['createUser', 'lastUpdateUser', 'flowId', 'tempVersion', 'extendFields'];
  const systemDic = ['auditStatus'];

  if (systemText.includes(item.prop)) {
    item.type = 'input';
    item.disabled = 'disabled';
  }

  if (systemDic.includes(item.prop)) {
    item.type = 'select';
    item.disabled = 'disabled';
    item.readonly = 'readonly';
  }

  // if (systemData.includes(item.prop)) {
  //   item.type = 'date';
  //   item.format = 'yyyy-MM-dd';
  // }

  if (systemTime.includes(item.prop)) {
    item.type = 'datetime';
    item.format = 'yyyy-MM-dd HH:mm:ss';
  }

  // 默认禁止编辑
  item.disabled = 'disabled';
};

export function getBizDictData(bizDic) {
  return new Promise((resolve, reject) => {
    commonApi
      .getDic(bizDic)
      .then((res) => {
        const dicData = res.data.data;
        resolve(dicData);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * setCellStyle
 * @export
 * @param {*} item
 * @param {*} option {fitColumnWidth: boolean, isManageList: boolean, readOnly: boolean}
 */
export function setCellStyle(item, option) {
  item.overHidden = true;

  if (option.fitColumnWidth === true) {
    if (option.isVxeTable === true) {
      const exception = item.exception || {};
      item.width = exception.width || '';
    }

    return;
  }

  let width = parseInt(item.width || 0, 10) || 0;

  const lableWidthStyle = getLableWidth(item.label);

  if (!item.width) {
    width =
      option.readOnly === true
        ? DATATYPE_COLUMN_WIDTH[item.datatype || 'default']
        : DATATYPE_COLUMN_WIDTH.default;
  }

  item.width = width && width > lableWidthStyle ? width : lableWidthStyle;
}

export function setRequired(item) {
  const label = item.displayName || item.label;
  const tip = (item.pleaseInput || LABELS.pleaseEnter) + label;

  const rule = {
    required: true,
    message: tip,
    trigger: 'blur'
  };

  if (item.bizDic || item.dicData) {
    rule.trigger = 'change';
  }

  if (item.datatype === 'date' || item.datatype === 'datetime') {
    rule.type = 'date';
  }

  if (item.datatype === 'number') {
    rule.type = 'number';
  }

  if (item.datatype === 'price') {
    rule.type = 'number';
  }

  if (!item.rules) {
    item.rules = [];
  }

  addRules(rule, item.rules);
}

export async function updateBizDicItem(item) {
  item.dicData = await getBizDictData(item.bizDic);
}

export const UTILS = {
  filterColumn,
  setDisplayName,
  setI18n
};

async function filterColumn(columns) {
  for (const item of columns) {
    if (this.enAbleI18n) {
      setI18n(item);
    } else {
      setDisplayName(item);
    }

    await checkDataType(item);

    if (typeof item.value !== 'undefined') {
      this.defaultValues[item.prop] = item.value;
      delete item.value;
    } else if (item.type === 'radio' && item.dicData && item.dicData.length > 0) {
      if (item.dicData[0] && typeof item.dicData[0].value !== 'undefined') {
        this.defaultValues[item.prop] = item.dicData[0].value;
      }
    }

    // this.checkSlot(item);

    const isRequired = item.isRequired === true || item.isRequired === 'Y';

    if (isRequired) {
      this.requiredColumns[item.prop] = 1;

      setRequired(item);
    }

    if (
      item.isDisabled === 'Y' ||
      item.isReadOnly === 'Y' ||
      this.readOnly ||
      item.ref ||
      item.disabled === 'disabled'
    ) {
      item.disabled = 'disabled';
      item.cell = false;
      item.rules = [];
    } else {
      item.cell = true;
    }

    setCellStyle(item, {
      fitColumnWidth: this.fitColumnWidth,
      isManageList: this.isManageList,
      readOnly: this.readOnly === true || this.readOnly === 'true'
    });

    item.display = true;
    // 如果是系统必填字段
    if (item && item.isRequired === 'Y') {
      this.requiredColumns[item.prop] = 1;

      setRequired(item);

      if (item.type === 'varchart' && item.isUserInput === 'N') {
        item.cell = false;
      }

      item.display = true;
    }
  }

  return columns;
}

function setDisplayName(item) {
  if (item.displayName && !item.displayName.includes('i18n_')) {
    item.label = item.displayName;
  }
  item.pleaseInput = LABELS.pleaseEnter;
}

function setI18n(item) {
  const i18nKey = item.i18nKey;

  const $t = this.$ft.bind(this);
  const isI18n = typeof $t === 'function';

  if (isI18n && i18nKey) {
    item.label = $t(i18nKey, item.label);
  }

  item.pleaseInput = LABELS.pleaseEnter;
}

function getLableWidth(label) {
  const labelLength = label.length;
  const displayWidth = 20 * labelLength;

  return displayWidth;
}

function setValidateNumber(item) {
  function validateIsPositiveNumber(rule, value, callback) {
    const label = item.displayName || item.label;
    const pleaseInputLable = item.pleaseInput || LABELS.pleaseEnter;
    const minValue = typeof item.min !== 'undefined' ? Number(item.min) : null;
    const maxValue = typeof item.max !== 'undefined' ? Number(item.max) : null;

    let tipDetail = '';

    if (typeof minValue === 'number' && typeof maxValue === 'number') {
      tipDetail = LABELS.numberGreaterEqualAndLessEqual
        .replace('?', minValue)
        .replace('?', maxValue);
    } else if (typeof maxValue === 'number') {
      tipDetail = LABELS.numberGreaterAndLessEqual.replace('?', '0').replace('?', maxValue);
    } else if (typeof minValue === 'number') {
      tipDetail = LABELS.numberGreaterEqual.replace('?', minValue);
    } else {
      tipDetail = LABELS.numberGreater.replace('?', '0');
    }

    const tip = `${label}: ${pleaseInputLable} ${tipDetail}`;

    if (!((item.isRequired && item.isRequired === true) || item.isRequired === 'Y')) {
      if (validateNull(value)) {
        if (callback && typeof callback === 'function') {
          callback();
        }

        return;
      }
    }

    const numberValue = Number(value);
    let isVerified =
      (typeof value === 'number' || typeof value === 'string') && !isNaN(numberValue);

    if (isVerified) {
      if (typeof maxValue === 'number' && numberValue - maxValue > 0) {
        isVerified = false;
      }

      if (typeof minValue === 'number') {
        if (minValue - numberValue > 0) {
          isVerified = false;
        }
      } else if (numberValue <= 0) {
        isVerified = false;
      }
    }

    if (callback && typeof callback === 'function') {
      isVerified ? callback() : callback(new Error(tip));
    } else {
      return {
        isVerified,
        message: tip
      };
    }
  }

  const rule = { validator: validateIsPositiveNumber, trigger: 'blur' };

  if (!item.rules) {
    item.rules = [];
  }

  addRules(rule, item.rules);
}

function setValidateNumber4Vxe(item) {
  function validateIsPositiveNumber({
    $table,
    cellValue,
    column,
    columnIndex,
    row,
    rowIndex,
    rule,
    rules
  }) {
    const label = item.displayName || item.label;
    const pleaseInputLable = item.pleaseInput || LABELS.pleaseEnter;
    const minValue = typeof item.min !== 'undefined' ? Number(item.min) : null;
    const maxValue = typeof item.max !== 'undefined' ? Number(item.max) : null;

    let tipDetail = '';

    if (typeof minValue === 'number' && typeof maxValue === 'number') {
      tipDetail = LABELS.numberGreaterEqualAndLessEqual
        .replace('?', minValue)
        .replace('?', maxValue);
    } else if (typeof maxValue === 'number') {
      tipDetail = LABELS.numberGreaterAndLessEqual.replace('?', 0).replace('?', maxValue);
    } else if (typeof minValue === 'number') {
      tipDetail = LABELS.numberGreaterEqual.replace('?', minValue);
    } else {
      tipDetail = LABELS.numberGreater.replace('?', '0');
    }

    const tip = `${label}: ${pleaseInputLable} ${tipDetail}`;

    if (!((item.isRequired && item.isRequired === true) || item.isRequired === 'Y')) {
      if (validateNull(cellValue)) {
        return;
      }
    }

    const numberValue = Number(cellValue);
    let isVerified =
      (typeof cellValue === 'number' || typeof cellValue === 'string') && !isNaN(numberValue);

    if (isVerified) {
      if (typeof maxValue === 'number' && numberValue - maxValue > 0) {
        isVerified = false;
      }

      if (typeof minValue === 'number') {
        if (minValue - numberValue > 0) {
          isVerified = false;
        }
      } else if (numberValue <= 0) {
        isVerified = false;
      }
    }

    if (!isVerified) {
      return new Error(tip);
    }
  }

  const rule = { validator: validateIsPositiveNumber, trigger: 'blur' };

  if (!item.rules) {
    item.rules = [];
  }

  addRules(rule, item.rules);
}

// eslint-disable-next-line no-unused-vars
function setValidatePrice(item) {
  function validateIsProice(rule, value, callback) {
    const label = item.displayName || item.label;
    const precision = item.precision;
    const pleaseInputLable = item.pleaseInput || LABELS.pleaseEnter;
    const tip = `${label}: ${pleaseInputLable}${LABELS.integerOrDecimalGreater.replace('?', '0')}`;
    const tipDigit = `${label}: ${pleaseInputLable}${LABELS.numberWithTowDecimal}`;

    if (!((item.isRequired && item.isRequired === true) || item.isRequired === 'Y')) {
      if (validateNull(value)) {
        if (callback && typeof callback === 'function') {
          callback();
        }
        return;
      }
    }

    const isVerified = value && Number(value) > 0;

    if (isVerified) {
      const invalidPriceDigit = Number(value).toFixed(precision);

      if (callback && typeof callback === 'function') {
        if (value.length === invalidPriceDigit.length) {
          callback();
        } else {
          callback(new Error(tipDigit));
        }
      }
    } else {
      if (callback && typeof callback === 'function') {
        callback(new Error(tip));
      }
    }
  }

  const rule = { validator: validateIsProice, trigger: 'blur' };

  if (!item.rules) {
    item.rules = [];
  }

  addRules(rule, item.rules);
}
